import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '918053055551'; // Business phone number without +
  const defaultMessage = 'Hello, I am interested in your interior design services. I would like to book a consultation.';
  const encodedMessage = encodeURIComponent(defaultMessage);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a 
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 sm:bottom-6 md:bottom-10 right-4 sm:right-6 md:right-10 z-[100] w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-green-500 shadow-2xl rounded-full flex items-center justify-center hover:scale-110 transition-transform hover:bg-green-600 group" 
      aria-label="Contact on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <svg 
        fill="white" 
        height="20" 
        width="20" 
        className="sm:h-6 sm:w-6 md:h-8 md:w-8 group-hover:rotate-12 transition-transform duration-300"
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884 0 2.225.569 3.807 1.532 5.27l-.998 3.644 3.955-.913zm9.251-6.484c-.329-.165-1.948-.96-2.251-1.07-.301-.109-.521-.165-.74.165-.219.329-.849 1.07-1.041 1.29-.192.219-.384.247-.712.082-.329-.165-1.389-.512-2.645-1.633-.977-.872-1.635-1.95-1.826-2.28-.192-.329-.021-.506.144-.67.149-.148.329-.384.493-.576.164-.192.219-.329.329-.548.11-.219.055-.411-.027-.575-.082-.165-.74-1.782-1.014-2.44-.267-.639-.539-.554-.74-.564-.192-.01-.411-.012-.63-.012s-.576.082-.877.411c-.301.329-1.151 1.123-1.151 2.74s1.178 3.178 1.342 3.397c.164.219 2.319 3.541 5.617 4.965.785.339 1.397.541 1.874.692.788.25 1.506.215 2.073.13.632-.094 1.948-.795 2.223-1.562.274-.767.274-1.426.192-1.562-.082-.137-.301-.219-.63-.384z"></path>
      </svg>
      
      {/* Pulse animation for attention */}
      <div className="absolute inset-0 rounded-full bg-green-400 opacity-0 group-hover:opacity-30 animate-ping"></div>
    </a>
  );
};

export default WhatsAppButton;
